import { render, staticRenderFns } from "./SaveUser.vue?vue&type=template&id=b2feaa18&scoped=true"
import script from "./SaveUser.vue?vue&type=script&lang=js"
export * from "./SaveUser.vue?vue&type=script&lang=js"
import style0 from "./SaveUser.vue?vue&type=style&index=0&id=b2feaa18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2feaa18",
  null
  
)

export default component.exports